import {
	replaceHtml,
	mmToPx
} from '../utils/util';
import {
	getcellvalue
} from '../global/getdata';
import {
	luckysheetrefreshgrid
} from '../global/refresh';
import {
	rowLocation,
	colLocation,
	mouseposition
} from '../global/location';
import formula from '../global/formula';
import tooltip from '../global/tooltip';
import editor from '../global/editor';
import {
	modelHTML
} from './constant';
import {
	selectHightlightShow
} from './select';
import server from './server';
import sheetmanage from './sheetmanage';
import luckysheetFreezen from './freezen';
import menuButton from './menuButton';
import {
	getSheetIndex
} from '../methods/get';
import locale from '../locale/locale';
import Store from '../store';
import imageCtrl from './imageCtrl';
const printsetCtrl = {
	item: {
		linkType: 'external', //链接类型 external外部链接，internal内部链接
		linkAddress: '', //链接地址 网页地址或工作表单元格引用
		linkTooltip: '', //提示
	},
	printset: null,
	createDialog: function() {
		let _this = this;

		const _locale = locale();
		const printset = _locale.printset;
		const toolbarText = _locale.toolbar;
		const buttonText = _locale.button;

		$("#luckysheet-modal-dialog-mask").show();
		$("#luckysheet-printset-dialog").remove();

		let sheetListOption = '';
		Store.luckysheetfile.forEach(item => {
			sheetListOption += `<option value="${item.name}">${item.name}</option>`;
		})
		let content = `<div class="box">
                            <div class="box-item">
                                <label for="luckysheet-printset-dialog-pageSize">${printset.pageSize}：</label>
                                <select id="luckysheet-printset-dialog-pageSize">
                                    <option value="A4" selected="selected">${printset.A4}</option>
                                    <option value="A5">${printset.A5}</option>
									<option value="customize">${printset.customize}</option>
                                </select>
                            </div>
							<div class="box-item" style="display:none" id="customizeWidth">
							   <label for="luckysheet-printset-dialog-customizeWidth">${printset.customizeWidth}：</label>
							     <input type="number"  id="luckysheet-printset-dialog-customizeWidth" style="width:70px"/>mm
							    <label for="luckysheet-printset-dialog-customizeHeight">${printset.customizeHeight}：</label>
							      <input type="number" id="luckysheet-printset-dialog-customizeHeight" style="width:70px"/>mm
							</div>
                            <div class="box-item">
                                <label for="luckysheet-printset-dialog-paperRotation">${printset.paperRotation}：</label>
                                <select id="luckysheet-printset-dialog-paperRotation">
                                    <option value="横向">${printset.crossrange}</option>
                                    <option value="纵向">${printset.crosswise}</option>
                                </select>
                            </div>
							<div class="box-item">
							    <label for="luckysheet-printset-dialog-pageMargin">${printset.pageMargin}：</label>
							</div>
							<div class="box-item">
							    <label for="luckysheet-printset-dialog-pageTop">${printset.pageTop}：</label>
								  <input type="number" id="luckysheet-printset-dialog-pageTop" value="0"  style="width:70px"/>mm
								 <label for="luckysheet-printset-dialog-pageButtom">${printset.pageButtom}：</label>
								   <input type="number" id="luckysheet-printset-dialog-pageButtom" value="0"  style="width:70px"/>mm
							</div>
							<div class="box-item">
							    <label for="luckysheet-printset-dialog-pageLeft">${printset.pageLeft}：</label>
								  <input type="number" id="luckysheet-printset-dialog-pageLeft" value="0"  style="width:70px"/>mm
								 <label for="luckysheet-printset-dialog-pageRight">${printset.pageRight}：</label>
								   <input type="number" id="luckysheet-printset-dialog-pageRight" value="0"  style="width:70px"/>mm
							</div>
                        </div>`;

		$("body").append(replaceHtml(modelHTML, {
			"id": "luckysheet-printset-dialog",
			"addclass": "luckysheet-printset-dialog",
			"title": toolbarText.printset,
			"content": content,
			"botton": `<button id="luckysheet-printset-dialog-confirm" class="btn btn-primary">${buttonText.confirm}</button>
                        <button class="btn btn-default luckysheet-model-close-btn">${buttonText.cancel}</button>`,
			"style": "z-index:100003"
		}));
		let $t = $("#luckysheet-printset-dialog").find(".luckysheet-modal-dialog-content").css("min-width", 350)
			.end(),
			myh = $t.outerHeight(),
			myw = $t.outerWidth();
		let winw = $(window).width(),
			winh = $(window).height();
		let scrollLeft = $(document).scrollLeft(),
			scrollTop = $(document).scrollTop();
		$("#luckysheet-printset-dialog").css({
			"left": (winw + scrollLeft - myw) / 2,
			"top": (winh + scrollTop - myh) / 3
		}).show();

		$('#luckysheet-printset-dialog-pageSize').change(function(e) {
			if (e.target.value == 'customize') {
				$("#luckysheet-printset-dialog-customizeWidth").val("0");
				$("#luckysheet-printset-dialog-customizeHeight").val("0");
				$('#customizeWidth').show();
			} else {
				$('#customizeWidth').hide();
			}
		})
		_this.dataAllocation();
	},
	init: function() {
		let _this = this;

		const _locale = locale();
		const printset = _locale.printset;
		//链接类型
		$(document).off("change.linkType").on("change.linkType", "#luckysheet-printset-dialog-linkType",
			function(e) {
				let value = this.value;
				$("#luckysheet-printset-dialog .show-box").hide();
				$("#luckysheet-printset-dialog .show-box-" + value).show();
			})

		//确认按钮
		$(document).off("click.confirm").on("click.confirm", "#luckysheet-printset-dialog-confirm", function(
			e) {

			//文本
			let pageSize = $("#luckysheet-printset-dialog-pageSize  option:selected").val();

			let paperRotation = $("#luckysheet-printset-dialog-paperRotation  option:selected").text();
			let paddingTop = $("#luckysheet-printset-dialog-pageTop").val();
			let paddingBottom = $("#luckysheet-printset-dialog-pageButtom").val();
			let paddingLeft = $("#luckysheet-printset-dialog-pageLeft").val();
			let paddingRight = $("#luckysheet-printset-dialog-pageRight").val();
			let pageWidth = $("#luckysheet-printset-dialog-customizeWidth").val();
			let pageHeight = $("#luckysheet-printset-dialog-customizeHeight").val();
			let item = {
				pageSize: pageSize,
				paperRotation: paperRotation,
				paddingTop: paddingTop,
				paddingBottom: paddingBottom,
				paddingLeft: paddingLeft,
				paddingRight: paddingRight,
				pageWidth: pageWidth,
				pageHeight: pageHeight,
				pageWidthBak: pageWidth,
				pageHeightBak: pageHeight,
			}
			let width = "210";
			let height = "297";
			if (item.pageSize == 'A4') {
				item.pageWidthBak = "210";
				item.pageHeightBak = "297"
			}
			if (item.pageSize == 'A5') {
				item.pageWidthBak = "148";
				item.pageHeightBak = "210"
			}
			if (item.pageSize == 'customize') {
				item.pageWidthBak = pageWidth;
				item.pageHeightBak  = pageHeight;
			}
			if (item.paperRotation == '横向') {
				item.pageWidth = item.pageHeightBak;
				item.pageHeight = item.pageWidthBak;
			}
			
			
			Store.printset = JSON.stringify(item);
			$("#luckysheet-sheettheight").css("top",mmToPx(item.pageHeight-item.paddingTop-item.paddingBottom) + 'px');
			$("#luckysheet-sheettwidth").css("margin-left",mmToPx(item.pageWidth -item.paddingLeft-item.paddingRight)+ 'px');
			$("#luckysheet-modal-dialog-mask").hide();
			$("#luckysheet-printset-dialog").hide();
			let file = Store.luckysheetfile[Store.currentSheetIndex];
			if (file.imagesBackGround != undefined && file.imagesBackGround.src != undefined) {
				imageCtrl.backgroundimageload(file.imagesBackGround);
				$("#luckysheet-imgBackgroundUpload").hide();
				$("#beijingtupian").remove();
				$("#beijing").before("<div id=\"beijingtupian\" style=\"float:left;overflow: hidden;width:70px\"> 背景图"+file.index+".jpg</div>")
				$("#shangchuan").removeClass('icon-yunshangchuan_o');
				$("#shangchuan").addClass('luckysheet-iconfont-shanchu');
				$("#shifoudayin").removeClass('icon-kaiguankai');
				$("#shifoudayin").css("color", "") 
				$("#shifoudayin").addClass('icon-kaiguanguan');
			} else {
				$("#luckysheet-sheettheightss").remove()
				$("#luckysheet-imgBackgroundUpload").hide();
				$("#beijingtupian").remove();
				$("#shangchuan").removeClass('icon-yunshangchuan_o');
				$("#shangchuan").addClass('luckysheet-iconfont-shanchu');
				$("#shifoudayin").removeClass('icon-kaiguankai');
				$("#shifoudayin").addClass('icon-kaiguanguan');
				$("#shifoudayin").css("color", "") 
			}
		})
	},
	dataAllocation: function() {
		let _this = this;
		let printset = {
			paddingLeft:0,
			paddingTop:0,
			paddingRight:0,
			paddingBottom:0
		};
		if (Store.printset != undefined && Store.printset != "") {
			printset = JSON.parse(Store.printset)
		}
		if (printset.pageSize == 'customize') {
			$('#customizeWidth').show();
		} else {
			$('#customizeWidth').hide();
		}
		$("#luckysheet-printset-dialog-pageSize").val(printset.pageSize);
		$("#luckysheet-printset-dialog-paperRotation").val(printset.paperRotation);
		$("#luckysheet-printset-dialog-pageTop").val(printset.paddingTop);
		$("#luckysheet-printset-dialog-pageButtom").val(printset.paddingBottom);
		$("#luckysheet-printset-dialog-pageLeft").val(printset.paddingLeft);
		$("#luckysheet-printset-dialog-pageRight").val(printset.paddingRight);
		$("#luckysheet-printset-dialog-customizeWidth").val(printset.pageWidthBak);
		$("#luckysheet-printset-dialog-customizeHeight").val(printset.pageHeightBak);
	
	},
	cellFocus: function(r, c) {
		let _this = this;

		if (_this.hyperlink == null || _this.hyperlink[r + '_' + c] == null) {
			return;
		}

		let item = _this.hyperlink[r + '_' + c];

		if (item.linkType == 'external') {
			window.open(item.linkAddress);
		} else {
			let cellrange = formula.getcellrange(item.linkAddress);
			let sheetIndex = cellrange.sheetIndex;
			let range = [{
				row: cellrange.row,
				column: cellrange.column
			}];

			if (sheetIndex != Store.currentSheetIndex) {
				$("#luckysheet-sheet-area div.luckysheet-sheets-item").removeClass(
					"luckysheet-sheets-item-active");
				$("#luckysheet-sheets-item" + sheetIndex).addClass("luckysheet-sheets-item-active");

				sheetmanage.changeSheet(sheetIndex);
			}

			Store.luckysheet_select_save = range;
			selectHightlightShow(true);

			let row_pre = cellrange.row[0] - 1 == -1 ? 0 : Store.visibledatarow[cellrange.row[0] - 1];
			let col_pre = cellrange.column[0] - 1 == -1 ? 0 : Store.visibledatacolumn[cellrange.column[0] - 1];

			$("#luckysheet-scrollbar-x").scrollLeft(col_pre);
			$("#luckysheet-scrollbar-y").scrollTop(row_pre);
		}
	},
	overshow: function(event) {
		let _this = this;

		$("#luckysheet-hyperlink-overshow").remove();

		if ($(event.target).closest("#luckysheet-cell-main").length == 0) {
			return;
		}

		let mouse = mouseposition(event.pageX, event.pageY);
		let scrollLeft = $("#luckysheet-cell-main").scrollLeft();
		let scrollTop = $("#luckysheet-cell-main").scrollTop();
		let x = mouse[0] + scrollLeft;
		let y = mouse[1] + scrollTop;

		if (luckysheetFreezen.freezenverticaldata != null && mouse[0] < (luckysheetFreezen.freezenverticaldata[
				0] - luckysheetFreezen.freezenverticaldata[2])) {
			return;
		}

		if (luckysheetFreezen.freezenhorizontaldata != null && mouse[1] < (luckysheetFreezen
				.freezenhorizontaldata[0] - luckysheetFreezen.freezenhorizontaldata[2])) {
			return;
		}

		let row_index = rowLocation(y)[2];
		let col_index = colLocation(x)[2];

		let margeset = menuButton.mergeborer(Store.flowdata, row_index, col_index);
		if (!!margeset) {
			row_index = margeset.row[2];
			col_index = margeset.column[2];
		}

		if (_this.hyperlink == null || _this.hyperlink[row_index + "_" + col_index] == null) {
			return;
		}

		let item = _this.hyperlink[row_index + "_" + col_index];
		let linkTooltip = item.linkTooltip;

		if (linkTooltip == null || linkTooltip.replace(/\s/g, '') == '') {
			linkTooltip = item.linkAddress;
		}

		let row = Store.visibledatarow[row_index],
			row_pre = row_index - 1 == -1 ? 0 : Store.visibledatarow[row_index - 1];
		let col = Store.visibledatacolumn[col_index],
			col_pre = col_index - 1 == -1 ? 0 : Store.visibledatacolumn[col_index - 1];

		if (!!margeset) {
			row = margeset.row[1];
			row_pre = margeset.row[0];

			col = margeset.column[1];
			col_pre = margeset.column[0];
		}

		let html = `<div id="luckysheet-hyperlink-overshow" style="background:#fff;padding:5px 10px;border:1px solid #000;box-shadow:2px 2px #999;position:absolute;left:${col_pre}px;top:${row + 5}px;z-index:100;">
                        <div>${linkTooltip}</div>
                        <div>单击鼠标可以追踪</div>
                    </div>`;

		$(html).appendTo($("#luckysheet-cell-main"));
	},
	ref: function(historyHyperlink, currentHyperlink, sheetIndex, d, range) {
		let _this = this;

		if (Store.clearjfundo) {
			Store.jfundo.length = 0;

			let redo = {};
			redo["type"] = "updateHyperlink";
			redo["sheetIndex"] = sheetIndex;
			redo["historyHyperlink"] = historyHyperlink;
			redo["currentHyperlink"] = currentHyperlink;
			redo["data"] = Store.flowdata;
			redo["curData"] = d;
			redo["range"] = range;
			Store.jfredo.push(redo);
		}

		_this.hyperlink = currentHyperlink;
		Store.luckysheetfile[getSheetIndex(sheetIndex)].hyperlink = currentHyperlink;

		Store.flowdata = d;
		editor.webWorkerFlowDataCache(Store.flowdata); //worker存数据
		Store.luckysheetfile[getSheetIndex(sheetIndex)].data = Store.flowdata;

		//共享编辑模式
		if (server.allowUpdate) {
			server.saveParam("all", sheetIndex, currentHyperlink, {
				"k": "hyperlink"
			});
			server.historyParam(Store.flowdata, sheetIndex, range[0]);
		}

		setTimeout(function() {
			luckysheetrefreshgrid();
		}, 1);
	},
    intPrint()
	{
		let printset = {
			paddingLeft:0,
			paddingTop:0,
			paddingRight:0,
			paddingBottom:0
		};
		if (Store.printset != undefined && Store.printset != "") {
			//console.log("ddhhhhd" + Store.printset)
			printset = JSON.parse(Store.printset)
			if(printset.pageWidth!=undefined)
			{
				$("#luckysheet-sheettheight").css("top",mmToPx(printset.pageHeight-printset.paddingTop-printset.paddingBottom)+'px');
					$("#luckysheet-sheettwidth").css("margin-left",mmToPx(printset.pageWidth-printset.paddingLeft-printset.paddingRight) + 'px');
				
			}
			else{
				$("#luckysheet-sheettheight").hide();
				$("#luckysheet-sheettwidth").hide();
			}
			}
		else{
			$("#luckysheet-sheettheight").hide();
			$("#luckysheet-sheettwidth").hide();
		}
	
	},
	
}

export default printsetCtrl;
